import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function getCustomerReferrals(customerId, page, pageSize) {
  const pagingParams =
    page !== undefined && pageSize !== undefined
      ? `?page=${page}&pageSize=${pageSize}`
      : "";

  const request = axios.get(
    `${urls.GET_CUSTOMER_REFERRALS_URL.replace(":customerId", customerId)}${pagingParams}`,
    { headers: { "Content-Type": "application/json" } }
  );

  return { type: ActionTypes.GET_CUSTOMER_REFERRALS, payload: request };
}

export function getCustomerReferralCode(customerId) {
  const request = axios.get(`${urls.GET_CUSTOMER_REFERRAL_CODE.replace(":customerId", customerId)}`, { headers: { "Content-Type": "application/json" } })
  return { type: ActionTypes.GET_CUSTOMER_REFERRAL_CODE, payload: request };
}

export function createCustomerReferralCode(customerId) {
  const request = axios.get(`${urls.CREATE_CUSTOMER_REFERRAL_CODE.replace(":customerId", customerId)}`, { headers: { "Content-Type": "application/json" } })
  return { type: ActionTypes.CREATE_CUSTOMER_REFRRAL_CODE, payload: request };
}
// export function getOrders(page, pageSize, customerId) {
//   const pagingParams =
//     page !== undefined && pageSize !== undefined
//       ? `?page=${page}&pageSize=${pageSize}`
//             : "";

//     const url = `${urls.CUSTOMER_ORDERS_URL.replace(":customerId", customerId)}${pagingParams}`;
//   const request = axios.get(url);

//     return { type: ActionTypes.GET_ORDERS, payload: request };
// }

// export function getOrder(id) {
//     const url = `${urls.ORDER_DETAILS_URL.replace(":id", id)}`;
//   const request = axios.get(url);
//   return { type: ActionTypes.GET_ORDER, payload: request };
// }

// export function clearOrder() {
//     return { type: ActionTypes.CLEAR_ORDER, payload: null };
// }

//export function setActivePage(page) {
//  return { type: ActionTypes.SET_ACTIVE_PAGE, payload: page };
//}

//export function setPager(page, totalPages) {
//  return {
//    type: ActionTypes.SET_PAGER,
//    payload: { activePage: page, totalPages: totalPages }
//  };
//}
